import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

export function useDraftCompaction() {
  return useMutation({
    mutationFn: async (conversationId) => {
      const { data } = await apiClient.post(`/conversations/${conversationId}/compact/draft`);
      return data;
    },
  });
}

export function useConfirmCompaction() {
  return useMutation({
    mutationFn: async ({ conversationId, summary }) => {
      const { data } = await apiClient.post(`/conversations/${conversationId}/compact`, { summary });
      return data;
    },
  });
}
